// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_aVd","cls2":"ActionNav-cls2_HN8 ActionNav-cls1_aVd"};